import React, { Component } from 'react';
import classes from './UploadResourceFiles.module.css';

import Button from '../../../UI/Button/Button';
import { IsObjectEmpty, IsStringEmpty } from '../../../../utilities/CommonMethods';
import ResourceAPIController from '../../../../webServices/ResourceAPIController';
import Input from '../../../UI/Input/Input';
import { GetObjectClone } from '../../../../utilities/CommonMethods';
import FormFields from '../../../Forms/FormFields';
import QuizOption from '../../../UI/QuizOption/QuizOption';
import ShowLoader from '../../../../hoc/ShowLoader/ShowLoader';


class UploadResourceFiles extends Component {
    state = {
        showDeleteOption: false,
        showPopupLoader: false,
        showSuccessMessage: false,
        messageList: [],
        showUploadDialog: false,
        file: null,
        filename: '',
        showFileOptions: false,
        uploadResourcesFormData: GetObjectClone(FormFields.uploadResources),
        uploadResourcesFormIsValid: false,

        uploadOptions: [
            { optionData: 'Upload File', type: "text", selected: true, value: 'uploadFile' },
            { optionData: 'Embed Link', type: "text", selected: false, value: 'embed' }
        ],
        activeUploadType: 0,
        showError: false,
        errorMessage: '',
        fileExtension: '',
        addNewFileOptions: false,
        selectedFileType: '',
        isFileSelected: false,
        fileTypeError: false,
        fileErrorMessage: '',
        disabledButton: true,
        embedLink: '',
        embedLinkError: ''
    }
    closePopup = () => {
        this.setState({ showUploadDialog: false, showPopupLoader: false })
    }

    onOptionClicked = (optionPos) => {
        let updatedOptions = [...this.state.uploadOptions];
        for (var i = 0; i < updatedOptions.length; i++) {
            if (i === optionPos) {
                updatedOptions[optionPos].selected = true;
                this.setState({ fileErrorMessage: '' })
            } else {
                updatedOptions[i].selected = false;
            }
        }

        let updatedForm = this.state.uploadResourcesFormData;

        for (let inputIdentifier in updatedForm) {
            if (!IsObjectEmpty(updatedForm[inputIdentifier].validation.required) && updatedForm[inputIdentifier].validation.required.value) {
                updatedForm[inputIdentifier].valid = true;
                updatedForm[inputIdentifier].value = '';
            }
        }
        this.setState({ uploadResourcesFormData: updatedForm, activeUploadType: optionPos, uploadOptions: updatedOptions, embedLink: '', embedLinkError: '' });
    }

    onFileSelected = (event) => {
        if ((event.target !== undefined && event.target.files.length > 0) || event.length > 0) {
            const file = event.target !== undefined ? event.target.files[0] : event[0];
            const fileName = file.name;
            const fileExtension = file.name.split('.').pop();
            const fileSize = file.size;
            this.setState({ isFileSelected: true })
            const allowedFileTypes = ['doc', 'docx', 'pdf', 'ppt', 'pptx', 'js', 'rtf', 'py', 'c', 'html', 'txt', 'css', 'xml'];
            if (allowedFileTypes.indexOf(fileExtension) < 0) {
                this.setState({ fileErrorMessage: 'File type not supported. Please upload a valid file.' })
                // this.props.onFailureDialogShow('File type not supported. Please upload a valid file.', 'OKAY')
                return;
            } else if (event.length > 1) {
                this.setState({ fileErrorMessage: 'Please select single file.' })
                // this.props.onFailureDialogShow('Please select single file.', 'OKAY')
                return;
            }
            else if (fileSize <= 2147483648) {
                this.setState({
                    showPopupLoader: false,
                    file: file,
                    showUploadDialog: false,
                    selectedFileType: fileExtension,
                    disabledButton: false,
                    fileErrorMessage: ''
                });
            }
        }
        else {
            alert("File not selected!")
        }
    }

    onSaveResourcesClick = (fileTitle) => {

        let data = new FormData();
        data.append('name', fileTitle);
        data.append('file', this.state.file);

        if (this.state.selectedFileType.toLowerCase() === 'pdf')
            this.addResourcesPDF(data);

        else if (this.state.selectedFileType.toLowerCase() === 'ppt' || this.state.selectedFileType.toLowerCase() === 'pptx')
            this.addResourcesSlides(data);

        else
            this.addResourcesOtherFile(data);
    }


    addResourcesPDF = (data) => {
        ResourceAPIController.addResourcesPDF(this.props.topicId, data)
            .then(response => {
                let responseObj = response.result;
                // console.log('Add Resources => ', responseObj)

                this.setState({
                    showPopupLoader: false,
                    showSuccessDialog: true,
                    showUploadDialog: false
                });
                this.props.onSuccessDialogShow("Resource File added successfully", 'OKAY');
                this.props.closeModal();
                this.props.onUploadSuccessful();
            })
            .catch(err => {
                console.log('Add Resources error => ', err)
                this.setState({ showPopupLoader: false });
                if (IsObjectEmpty(err.error)) {
                    // LogParsingError('ParsingError: MainLayout: ' + err.toString(), EndPoints.SIGNED_IN_COMMON_DATA, responseObj);
                    return;
                }
                if (err.error.status === 400) {
                    this.props.onFailureDialogShow(err.error.message, 'OKAY');
                }
                if (err.error.status === 401) {
                    if (err.error.message === 'Invalid token.') {
                        this.props.showSessionExpiredDialog(true);
                    } else {
                        this.props.redirectToUnauthorized();
                    }
                }
                if (err.error.status === 404) {
                    this.props.redirectToNotFound();
                }
                if (err.error.status === 500) {
                    this.props.redirectToServerError();
                }
            });
    }

    addResourcesSlides = (data) => {
        ResourceAPIController.addResourcesSlides(this.props.topicId, data)
            .then(response => {
                let responseObj = response.result;
                // console.log('Add Resources => ', responseObj)
                this.setState({
                    showPopupLoader: false,
                    showSuccessDialog: true,
                    showUploadDialog: false
                });
                this.props.onSuccessDialogShow("Resource File added successfully", 'OKAY');
                this.props.closeModal();
                this.props.onUploadSuccessful();
            })
            .catch(err => {
                console.log('Add Resources error => ', err)
                this.setState({ showPopupLoader: false });
                if (IsObjectEmpty(err.error)) {
                    // LogParsingError('ParsingError: MainLayout: ' + err.toString(), EndPoints.SIGNED_IN_COMMON_DATA, responseObj);
                    return;
                }
                if (err.error.status === 400) {
                    this.props.onFailureDialogShow(err.error.message, 'OKAY');
                }
                if (err.error.status === 401) {
                    if (err.error.message === 'Invalid token.') {
                        this.props.showSessionExpiredDialog(true);
                    } else {
                        this.props.redirectToUnauthorized();
                    }
                }
                if (err.error.status === 404) {
                    this.props.redirectToNotFound();
                }
                if (err.error.status === 500) {
                    this.props.redirectToServerError();
                }
            });
    }

    addResourcesOtherFile = (data) => {
        ResourceAPIController.addResourcesOtherFile(this.props.topicId, data)
            .then(response => {
                let responseObj = response.result;
                // console.log('Add Resources => ', responseObj)
                this.setState({
                    showPopupLoader: false,
                    showSuccessDialog: true,
                    showUploadDialog: false
                });
                this.props.onSuccessDialogShow("Resource File added successfully", 'OKAY');
                this.props.closeModal();
                this.props.onUploadSuccessful();
            })
            .catch(err => {
                console.log('Add Resources error => ', err)
                this.setState({ showPopupLoader: false });
                if (IsObjectEmpty(err.error)) {
                    // LogParsingError('ParsingError: MainLayout: ' + err.toString(), EndPoints.SIGNED_IN_COMMON_DATA, responseObj);
                    return;
                }
                if (err.error.status === 400) {
                    this.props.onFailureDialogShow(err.error.message, 'OKAY');
                }
                if (err.error.status === 401) {
                    if (err.error.message === 'Invalid token.') {
                        this.props.showSessionExpiredDialog(true);
                    } else {
                        this.props.redirectToUnauthorized();
                    }
                }
                if (err.error.status === 404) {
                    this.props.redirectToNotFound();
                }
                if (err.error.status === 500) {
                    this.props.redirectToServerError();
                }
            });
    }

    addEmbedResourceLink = (data) => {
        ResourceAPIController.addEmbedResourceLink(this.props.topicId, data)
            .then(response => {
                let responseObj = response.result;
                // console.log('Add Resources Embed Link => ', responseObj)
                this.setState({
                    showPopupLoader: false,
                    showSuccessDialog: true,
                    showUploadDialog: false
                });
                this.props.onSuccessDialogShow("Resource File added successfully", 'OKAY');
                this.props.closeModal();
                this.props.onUploadSuccessful();
            })
            .catch(err => {
                console.log('Add Resources error => ', err)
                this.setState({ showPopupLoader: false });
                if (IsObjectEmpty(err.error)) {
                    // LogParsingError('ParsingError: MainLayout: ' + err.toString(), EndPoints.SIGNED_IN_COMMON_DATA, responseObj);
                    return;
                }
                if (err.error.status === 400) {
                    this.props.onFailureDialogShow(err.error.message, 'OKAY');
                }
                if (err.error.status === 401) {
                    if (err.error.message === 'Invalid token.') {
                        this.props.showSessionExpiredDialog(true);
                    } else {
                        this.props.redirectToUnauthorized();
                    }
                }
                if (err.error.status === 404) {
                    this.props.redirectToNotFound();
                }
                if (err.error.status === 500) {
                    this.props.redirectToServerError();
                }
            });
    }

    checkValidity = (formElement) => {
        let isValid = true;

        if (!IsObjectEmpty(formElement.validation)) {
            let value = formElement.value;
            const rules = formElement.validation;
            if (!IsObjectEmpty(rules.required) && rules.required.value) {
                if (typeof (value) === 'string' && value !== ' ' && value !== '' && value.length > 0) {
                    isValid = true && isValid;
                } else if ((typeof (value) === 'number' && parseInt(value, 10)) || value === 0) {
                    isValid = true && isValid;
                } else {
                    isValid = false;
                }
                formElement.errorMessage = isValid ? '' : rules.required.errorMessage;
                formElement.valid = isValid;
            }

            if (!IsObjectEmpty(rules.isDropdown) && rules.isDropdown.value) {
                isValid = (value >= 0) && isValid;
                formElement.errorMessage = isValid ? '' : rules.isDropdown.errorMessage;
                formElement.valid = isValid;
            }
        }
        return (formElement);
    }

    inputChangedHandlerText = (event, inputIdentifier) => {
        const updatedForm = this.state.uploadResourcesFormData;
        let updatedFormElement = updatedForm[inputIdentifier];

        updatedFormElement.value = event.target.value;

        updatedFormElement.touched = true;
        updatedFormElement = this.checkValidity(updatedFormElement, updatedForm);
        updatedForm[inputIdentifier] = updatedFormElement;

        let formIsValid = true;
        for (let inputIdentifier in updatedForm) {
            if (!IsObjectEmpty(updatedForm[inputIdentifier].validation.required) && updatedForm[inputIdentifier].validation.required.value) {
                formIsValid = updatedForm[inputIdentifier].valid && formIsValid;
            }
        }
        this.setState({ uploadResourcesFormData: updatedForm, uploadResourcesFormIsValid: formIsValid });
    }

    inputField = (key) => {
        return <Input
            inputIdentifier={key}
            elementType={this.state.uploadResourcesFormData[key].elementType}
            elementConfig={this.state.uploadResourcesFormData[key].elementConfig}
            label={this.state.uploadResourcesFormData[key].label}
            value={this.state.uploadResourcesFormData[key].value}
            options={this.state.uploadResourcesFormData[key].options}
            changed={(event) => this.inputChangedHandlerText(event, key)}
            touched={this.state.uploadResourcesFormData[key].touched}
            afterText={this.state.uploadResourcesFormData[key].remainingChar}
            dropdownOpen={this.state.uploadResourcesFormData[key].dropdownOpen}
            onDropDownClick={() => this.onDropDownClick(key)}
            onDropDownItemClick={this.onDropDownItemClick}
            videoType={this.props.videoType}
            required={!IsObjectEmpty(this.state.uploadResourcesFormData[key].validation) ? (!IsObjectEmpty(this.state.uploadResourcesFormData[key].validation.required) ? this.state.uploadResourcesFormData[key].validation.required.value : false) : false}
            showError={(!this.state.uploadResourcesFormIsValid && !this.state.uploadResourcesFormData[key].valid) ? true : false}
            error={this.state.uploadResourcesFormData[key].errorMessage} />
    }

    onInputChanged = (event) => {

        let updatedValue = event.target.value;
        let errorMessage = !IsStringEmpty(updatedValue) ? '' : 'Please enter a valid embed link';

        this.setState({ embedLink: updatedValue, embedLinkError: errorMessage });
    }

    onSaveFileTitle = () => {
        const updatedForm = this.state.uploadResourcesFormData;
        for (let item in updatedForm) {
            updatedForm[item] = this.checkValidity(updatedForm[item], updatedForm);
        }

        let formIsValid = true;
        if (!IsStringEmpty(updatedForm['fileTitle'].value) && updatedForm.fileTitle.value.trim() !== '') {
            updatedForm['fileTitle'].valid = true;
            formIsValid = true;
            this.setState({ uploadResourcesFormData: updatedForm, uploadResourcesFormIsValid: formIsValid });
        } else {
            updatedForm['fileTitle'].valid = false;
            updatedForm['fileTitle'].errorMessage = 'This is a required field';
            formIsValid = false;
            this.setState({ uploadResourcesFormData: updatedForm, uploadResourcesFormIsValid: formIsValid });
        }

        if (this.state.uploadOptions[0].selected === true) {
            if (formIsValid && !IsStringEmpty(updatedForm.fileTitle.value)) {
                this.setState({ fileTitle: updatedForm.fileTitle.value, disabledButton: false, fileErrorMessage: '', showPopupLoader: true });
                this.onSaveResourcesClick(updatedForm.fileTitle.value);
            }
        } else {
            if (!IsStringEmpty(this.state.embedLink) && this.state.embedLink.trim().length > 5 && formIsValid) {
                this.setState({ showPopupLoader: true })
                const data = {
                    'name': updatedForm.fileTitle.value,
                    'link': this.state.embedLink
                }
                this.addEmbedResourceLink(data);
            } else {
                this.setState({ embedLinkError: 'Please enter a valid embed link' })
            }
        }

    }

    onAddNewFileClick = () => {
        this.setState({ addNewFileOptions: true, showFileOptions: true });
    }

    render() {

        const renderUploadOptions = this.state.uploadOptions.map((option, index) => {
            return <QuizOption
                key={index}
                pos={index}
                selected={option.selected}
                questionId={'uploadType'}
                optionType={option.type}
                questionType={'single'}
                optionData={option.optionData}
                onOptionClicked={this.onOptionClicked}
            />
        });

        return (
            <div>
                {this.state.showFileOptions === false ?
                    <>
                        <p className={classes.SubHeading}>Resource Files</p>

                        <ul className={classes.ResourceFilesList}>
                            {
                                !IsObjectEmpty(this.props.resourceFiles) && !IsObjectEmpty(this.props.resourceFiles.files)
                                    ? this.props.resourceFiles.files.map((file, index) => {
                                        return <li key={index} className={classes.ResourceFileListItem}>{(index + 1) + '. ' + file.title}</li>
                                    }) : <li className={classes.ResourceFileListItem}>No files available!</li>
                            }
                        </ul>
                        <div className={classes.AlignRight}>
                            <Button label="ADD NEW FILE" margin="1em 0" styleclass="GoToCourseButton" clicked={() => this.onAddNewFileClick()} />
                        </div>
                    </> :
                    <div className={classes.Containerr} >

                        <>
                            <p className={[classes.SubHeading, classes.FileDetailsHeading].join(' ')}>Add New File</p>
                            <div className={classes.OptionsContainer}>
                                {renderUploadOptions}
                            </div>
                            {
                                this.state.activeUploadType === 0
                                    ? <>
                                        <div className={classes.FileDetailsDiv}>
                                            <div className={classes.FileTitle}>
                                                {this.inputField('fileTitle')}
                                            </div>
                                            <div className={classes.SelectFileInput}>
                                                <input type="file" onChange={this.onFileSelected} className={classes.FileInput} />
                                            </div>
                                        </div>
                                        {!IsStringEmpty(this.state.fileErrorMessage)
                                            ? <p className={classes.ErrorMessage}>{this.state.fileErrorMessage}</p>
                                            : null}
                                        <div className={classes.AlignRight}>
                                            {
                                                this.state.showPopupLoader
                                                    ? <div className={classes.LoaderContainer}>
                                                        <ShowLoader isLoading={true} transparentBg={true} />
                                                    </div>
                                                    : <Button
                                                        label="SAVE"
                                                        styleclass={this.state.disabledButton ? '' : "GoToCourseButton"}
                                                        clicked={this.state.disabledButton ? null : () => this.onSaveFileTitle()}
                                                        disabled={this.state.disabledButton} />
                                            }
                                        </div>
                                    </>
                                    : <>
                                        <div className={[classes.FileDetailsDiv, classes.RemoveFlex].join(' ')}>
                                            <div className={[classes.FileTitle, classes.FullWidth].join(' ')}>
                                                {this.inputField('fileTitle')}
                                            </div>
                                            <textarea
                                                rows="4"
                                                placeholder={'Paste embed code here'}
                                                value={this.state.embedLink}
                                                className={classes.TextInput}
                                                onChange={(event) => this.onInputChanged(event)}
                                            />
                                        </div>

                                        {!IsStringEmpty(this.state.embedLinkError)
                                            ? <p className={[classes.ErrorMessage, classes.TextAlignLeft].join(' ')}>{this.state.embedLinkError}</p>
                                            : null}
                                        <div className={classes.AlignRight}>
                                            {
                                                this.state.showPopupLoader
                                                    ? <div className={classes.LoaderContainer}>
                                                        <ShowLoader isLoading={true} transparentBg={true} />
                                                    </div>
                                                    : <Button
                                                        label="SAVE"
                                                        styleclass={"GoToCourseButton"}
                                                        clicked={() => this.onSaveFileTitle()}
                                                        disabled={false} />
                                            }
                                        </div>
                                    </>
                            }
                        </>

                    </div>}

            </div>
        );
    }
}

export default UploadResourceFiles;